/**
*  Copyright (c) 2020 Micro Focus Software Inc.  All Rights Reserved.
*
* THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
* AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
* WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
* TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
* AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
* INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
* PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
* CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
* OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
* ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
* THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
*/
import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { ZSDTranslateService } from '../../../../common/zsd-translate.service';
import { DomSanitizer } from '@angular/platform-browser';
import { CustomFieldInfo } from '../../items/model/itemdetailinfo';
import { ServiceItemDetailResponse, SlaContractInfo } from '../model/serviceitemsdetailinfo';
import { ServiceItemDetailService } from '../services/serviceitemsdetail.service';
import { CustomerPreferenceService } from '../../../../customer/preference/customerpreference.service';
import { CustomerPreferenceResponse } from '../../../../customer/preference/customerpreference.model';
import { CommonConstants } from '../../../../common/constants/common-constants';
import { Observable } from 'rxjs';
declare var $: any;

@Component({
  selector: 'zsd-serviceitemsdetail',
  templateUrl: '../view/serviceitemsdetail.component.html',
  styleUrls: ['../view/serviceitemsdetail.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ServiceItemsDetailComponent implements OnInit {
    itemId: number;
    serviceItemDetail: ServiceItemDetailResponse = new ServiceItemDetailResponse();
    customFieldInfo: CustomFieldInfo = new CustomFieldInfo();
    matrix = [];
    selectedTarget: string;
    canCreateServiceIncident: boolean;
    canCreateChangeRequests: boolean;
    canCreateServiceRequests: boolean;
    serviceLevelPerProcess = new Array<string>();
    commonServiceLevel: boolean;
    currentSlaTarget: SlaContractInfo[];
    canViewServiceTargets: boolean;
    showOutage = false;
    incident: string;
    service: string;
    change: string;
    customCategory;
    popupHeaderString;
    serviceType;
    fromMyServiceTab;
    fromMyServiceCatalog;
    imagePath;
    itemSelectionRequired: number;


    constructor(public serviceItemDetailService: ServiceItemDetailService, private route: ActivatedRoute,
        zsdTranslate: ZSDTranslateService, public router: Router, public _DomSanitizer: DomSanitizer,
        public customerPreferenceService: CustomerPreferenceService) {
        this.router.events.subscribe(
            () => {
                if (this.router.url.includes('/outages')) {
                    this.showOutage = true;
                }
            }
        );
        zsdTranslate.getTranslateService().get('ServiceItemsTargets.change').subscribe(
            (str: string) => {
                this.change = str;
            });
        zsdTranslate.getTranslateService().get('ServiceItemsTargets.incident').subscribe(
            (str: string) => {
                this.incident = str;
            });
        zsdTranslate.getTranslateService().get('ServiceItemsTargets.service').subscribe(
            (str: string) => {
                this.service = str;
            });

    }

  ngOnInit(): void {
      this.route.params.subscribe(params => {
          this.itemId = params['itemId'];
          if (params['serviceType']) {
          this.serviceType = params['serviceType'];
          if (this.serviceType === 'myservices') {
              this.fromMyServiceTab = true;
          }  if (this.serviceType === 'servicecatalog') {
              this.fromMyServiceCatalog = true;
          }
        }
      });
      this.customerPreferenceService.getPreferenceList().subscribe((preference: CustomerPreferenceResponse) => {
          // privilege to check whether item is required, optional or hided
          this.itemSelectionRequired = preference.itemSelectionRequired;
          // privilege check for create an incident icon
          this.canCreateServiceIncident = preference.canCreateServiceIncident;
          // privilege check to create change request icon
          this.canCreateChangeRequests = preference.canCreateChangeRequests;
          // privilege check to create service request icon
          this.canCreateServiceRequests = preference.canCreateServiceRequests;
          // privilege check to show service targets
          this.canViewServiceTargets = preference.showServiceTargets;
      });

      // fetching service item Detail

    let serviceDetailHTTP: Observable<ServiceItemDetailResponse> = null;

    if (this.showOutage) {
        serviceDetailHTTP = this.serviceItemDetailService.getOutageServiceItemDetail(this.itemId);
    } else {
        serviceDetailHTTP = this.serviceItemDetailService.getServiceItemDetail(this.itemId);
    }

      serviceDetailHTTP.subscribe((serviceItemDetailResponse: ServiceItemDetailResponse) => {
                  let chunkSize = 2;
                  this.serviceItemDetail = serviceItemDetailResponse;
                  let arr = this.serviceItemDetail.customFields;
          if (this.serviceItemDetail.serviceTargets != null) {
              if (this.serviceItemDetail.serviceTargets['common']) {
                  this.commonServiceLevel = true;
                  this.currentSlaTarget = this.serviceItemDetail.serviceTargets.common;
              } else {
                  if (this.serviceItemDetail.serviceTargets['change']) {
                      this.serviceLevelPerProcess.push(this.change);
                      this.currentSlaTarget = this.serviceItemDetail.serviceTargets.change;
                  }
                  if (this.serviceItemDetail.serviceTargets['service']) {
                      this.serviceLevelPerProcess.push(this.service);
                      this.currentSlaTarget = this.serviceItemDetail.serviceTargets.service;
                  }
                  if (this.serviceItemDetail.serviceTargets['incident']) {
                      this.serviceLevelPerProcess.push(this.incident);
                      this.currentSlaTarget = this.serviceItemDetail.serviceTargets.incident;
                  }
              }
          }
                  let groups = arr.map(function (e, i) {
                      return i % chunkSize === 0 ? arr.slice(i, i + chunkSize) : null;
                      console.log(e);
                  });
                  this.matrix = groups;
              });
  }

  refreshTableContent() {
      if (this.selectedTarget === this.change) {
          this.currentSlaTarget = this.serviceItemDetail.serviceTargets.change;
      }
      if (this.selectedTarget === this.service) {
          this.currentSlaTarget = this.serviceItemDetail.serviceTargets.service;
      }
      if (this.selectedTarget === this.incident) {
          this.currentSlaTarget = this.serviceItemDetail.serviceTargets.incident;
      }
  }
  createServiceIncident( sitemDetail: ServiceItemDetailResponse) {
    this.itemId = sitemDetail.itemBasicInfo.itemId;
    this.customCategory = 'incident';
    this.resetModal();
    this.localizeHeaderString();
}

    createChangeRequest( sitemDetail: ServiceItemDetailResponse) {
    this.itemId = sitemDetail.itemBasicInfo.itemId;
    this.customCategory = 'change';
    this.resetModal();
    this.localizeHeaderString();
 }

 createServiceRequest( sitemDetail: ServiceItemDetailResponse) {
    this.itemId = sitemDetail.itemBasicInfo.itemId;
    this.customCategory = 'service';
    this.resetModal();
    this.localizeHeaderString();
}

resetModal() {
    $('#zsd_modal_new_request .modal-header').css('display', 'inline-flex');
    $('#zsd_modal_new_request .modal-header').show();
    $('#zsd_modal_new_request').css('width', '100%');
    $('#zsd_modal_new_request').css('margin-left', '0');
    $('#request_success_msg').hide();
    $('#report_incident_row').show();
  }


  localizeHeaderString() {
    if (this.customCategory === 'incident') {
      this.popupHeaderString = 'NewRequest.incidentHeader';
      this.imagePath = 'img/createincidentheader.png';
    }
    if (this.customCategory === 'change') {
      this.popupHeaderString = 'NewRequest.changeRequestHeader';
      this.imagePath = 'img/createchangerequestheader.png';
    }
    if (this.customCategory === 'service') {
      this.popupHeaderString = 'NewRequest.serviceRequestHeader';
      this.imagePath = 'img/createservicerequestheader.png';
    }
  }

resetCreateRequest() {
this.customCategory = '';

}

cancel() {
    let serviceType;
    if (this.showOutage) {
        this.router.navigate([CommonConstants.OUTAGES_COMPONENT]);
    } else {
    if (this.fromMyServiceTab) {
        serviceType = 'myservices';
    }
    if (this.fromMyServiceCatalog) {
        serviceType = 'all';
    }
    serviceType =  JSON.stringify(serviceType);
    let navigationExtras: NavigationExtras = {
        queryParams: {
                  'serviceType':  serviceType
        },
        queryParamsHandling: 'merge'
      };
      this.router.navigateByUrl('/my-profile', { skipLocationChange: true }).then(() =>
        this.router.navigate([CommonConstants.SERVICES_COMPONENT], navigationExtras));
}
}

}
